


















































import {Component, Prop, Vue} from 'vue-property-decorator'

@Component
export default class InputColorHex extends Vue {
  @Prop({type: String, default: null}) value!: string | null
  @Prop({type: String, default: null}) label!: string | null
  @Prop({type: Boolean, default: false}) required!: boolean
  @Prop({type: Boolean, default: false}) disabled!: boolean

  get normalizedHexNoHash(): string | null {
    if (this.value === null || this.value === undefined) return null
    const raw = String(this.value).trim()
    if (!raw) return null

    const noHash = raw.startsWith('#') ? raw.slice(1) : raw
    if (!/^[0-9a-fA-F]{6}$/.test(noHash)) return null

    return noHash.toUpperCase()
  }

  get pickerValue(): string {
    // `<input type="color">` requires a valid #RRGGBB value.
    return this.normalizedHexNoHash ? `#${this.normalizedHexNoHash}` : '#000000'
  }

  get displayValue(): string {
    return this.normalizedHexNoHash ? `#${this.normalizedHexNoHash}` : '—'
  }

  onPickerInput(e: Event) {
    const next = (e.target as HTMLInputElement | null)?.value ?? ''
    const noHash = next.startsWith('#') ? next.slice(1) : next
    this.$emit('input', noHash.toUpperCase())
  }
}
